import { User } from 'app/user';

export class UserImport {
  constructor(
    public user: User,
    public errors: any
  ) { }
}



// WEBPACK FOOTER //
// /dist/src/app/import/user-import.model.ts